import { Navigate } from 'react-router';

import { AuditLogsContainer, AuditLogsContextProvider } from 'src/containers/AuditLogs';
import { usePageMeta } from 'src/hooks';
import { Main } from 'src/components/Layout';
import { withSuspense } from 'src/hoc';
import { CompanyDocument } from 'src/graphql/actions/company/company.query';
import { apolloCache as cache } from 'src/graphql';

import type { ICompanyQuery } from 'src/graphql/actions/company/company.query';

const Container = withSuspense(() => {
  return (
    <AuditLogsContextProvider>
      <AuditLogsContainer />
    </AuditLogsContextProvider>
  );
});

const AuditLogsPage = () => {
  usePageMeta('Activity log');

  const dataCompany = cache.readQuery<ICompanyQuery>({ query: CompanyDocument });

  if (dataCompany?.company.policy.readAuditLog)
    return (
      <Main title="Activity log" className="bg-background-secondary">
        <div className="container mx-auto flex flex-col h-full">
          <div className="space-y-1 mb-6">
            <div className="text-base font-semibold text-gray-700">Activity log</div>
            <p className="text-sm text-gray-500">Track all actions across your organization.</p>
          </div>
          <section className="relative grow">
            <Container />
          </section>
        </div>
      </Main>
    );

  return <Navigate to="/" />;
};

export default AuditLogsPage;
